import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    deleteParagraph: {
        marginTop: '2rem',
    },
    environmentDeleteInput: {
        marginTop: '1rem',
    },
}));
